<template>
  <div>
    <Hero/>
    <Features/>
    <background-wrapper color="#E0F0FF">
      <div class="scalable-hris">
        <ContentWithImage sectionName="scalable-hris" text-size="sm" justify-center image-order="1" image-order-sm="0" h2/>
      </div>
    </background-wrapper>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_ready-made-reports'" ext="png" bg-margin="200px">
      <div class="ready-made-reports">
        <ContentWithImage sectionName="ready-made-reports" text-size="sm" justify-center image-order="0" image-order-sm="0" image-margin="auto 0 auto 130px" margin="0" h2/>
      </div>
    </background-wrapper>
    <ContentWithImage sectionName="easy-to-create-organizational-chart" text-size="sm" justify-center image-order="1" image-order-sm="0" h2/>
    <ContentWithImage sectionName="easily-track-all-assignments" text-size="sm" justify-center image-order="0" image-order-sm="0" h2/>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_hr-fundamentals-included'" ext="png">
      <text-container class="hr-fundamentals-included" size="xl" align-center justify-center>
        <img class="product-icon mb-3" :src="require(`@/assets/fundamentals/fundamentals-icon.png`)"/>
        <h2 class="h1" v-html="$t(`products.${$route.name}.hr-fundamentals-included.title`)"/>
        <p class="h-sub" v-html="$t(`products.${$route.name}.hr-fundamentals-included.text`)"/>
        <b-btn to="/product/fundamentals" class="mt-2" variant="primary">
          {{$t(`learn-more`)}}
        </b-btn>
      </text-container>
    </background-wrapper>
    <RequestDemo/>
    <Tools/>
    <LetsGet/>
  </div>
</template>

<script>
import { Hero, Tools, LetsGet, Features, ContentWithImage, RequestDemo } from '@/components/ui/products'

export default {
  name: 'Drive',
  components: { Hero, Tools, LetsGet, Features, ContentWithImage, RequestDemo },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  }
}
</script>

<style lang="sass" scoped>
.scalable-hris
  display: flex
  flex-direction: column

.ready-made-reports
  display: flex
  flex-direction: column
  padding: 150px 0 420px
  +media-breakpoint-down(sm)
    padding: 150px 0 150px
  +media-breakpoint-down(xs)
    padding: 150px 0 calc(150px - (600px - 100vw)/2)
  +media-breakpoint-down(xxs)
    padding: 150px 0 calc(100px - (480px - 100vw)/2)

.product-icon
  width: 100px

.hr-fundamentals-included
  padding: 80px 0 280px
  @media screen and (min-width: 2000px)
    padding-top: calc((100vw - 2000px)/6 + 80px)
    padding-bottom: calc((100vw - 2000px)/6 + 280px)
  +media-breakpoint-down(sm)
    padding: 0 45px 380px 45px
  +media-breakpoint-down(xs)
    padding: 0 0 300px
</style>



// WEBPACK FOOTER //
// src/components/products/Drive/Drive.vue